exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gos-number-block[data-v-b987d702]{position:relative}.alert-russian-symbols[data-v-b987d702]{position:absolute;top:-5px;color:#ff5252;font-size:14px}.button[data-v-b987d702]{line-height:1.45!important;font-weight:700!important;font-size:18px!important;text-transform:none!important;-webkit-box-shadow:none!important;box-shadow:none!important;width:250px;height:60px;text-align:center;display:table-cell;vertical-align:middle;padding:0!important;margin:10px 20px 0 0;border-width:1px;border-radius:100px;border-style:solid}.button[data-v-b987d702] .v-btn__content{white-space:normal;padding:0 110px;line-height:1.1}.next-button[data-v-b987d702]{color:#fff!important;background-color:#00ba57!important;border-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b987d702","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/steps/StepZero.vue
// module id = Adm/
// module chunks = 0 1